export default {
    Metadata: {
        Name: "ToDate",
        Description: "Returns the given value as a date.",
        Syntax: "ToDate(value)",
        Keywords: ['Date', 'Conversion'],
        Author: "DataVoke, Inc.",
    },
    execute(fromValue) {
        //This fixes the dates that were NaN values...BC
        if (fromValue == null || fromValue == "") {
            return null;
        }

        try {
            return new Date(fromValue);
        } catch (e) {
            //Eat any exception...EK
        }

        //If code falls here, just return null...EK
        return null;
    },
};

